// Ported from deexoptions-mobile-app/utils/invalidateActivityQueries.ts.
//
// Post-trade flows call this to refresh every transaction list at once. It
// covers both the new `transactions` namespace and the PWA's hand-written
// legacy keys, so it stays correct while the two systems coexist.

import { QueryClient } from "@tanstack/react-query";
import { legacyActivityKeys } from "../hooks/queries/activityKeys";
import { transactionKeys } from "../hooks/queries/transactionKeys";

export function invalidateActivityQueries(queryClient: QueryClient) {
  return Promise.all([
    queryClient.invalidateQueries({ queryKey: transactionKeys.all }),
    ...Object.values(legacyActivityKeys).map((queryKey) =>
      queryClient.invalidateQueries({ queryKey })
    ),
  ]);
}
